import { useMutation, useQuery, useQueryClient } from "react-query";
import { editManufacturer, getManufacturerDetail } from "../../services/manufacturers";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { convertDate } from "../../utils";

function ManufacturerDetail() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const params = useParams();
  const manufacturerId = params.id;

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
  });

  const manufacturerDetailQuery = useQuery({
    queryKey: ["manufacturer-detail", manufacturerId],
    queryFn: () => getManufacturerDetail(manufacturerId),
    onSuccess(data) {
      setValue("manufacturer_name", data.manufacturer_name);
      setValue("order_num", data.order_num);
      setValue("updated_by", data.updated_by);
      setValue("updated_at", convertDate(data.updated_at));
    },
    onError(error) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const editManufacturerMutation = useMutation({
    mutationFn: editManufacturer,
    onError(error) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    onSuccess(data) {
      enqueueSnackbar("Edit Manufacturer success!", { variant: "success" });
      queryClient.invalidateQueries("manufacturer-detail");
    },
  });

  const handleSubmitForm = (values) => {
    const editData = {
      manufacturer_id: manufacturerId,
      manufacturer_name: values.manufacturer_name,
      order_num: values.order_num,
    };
    editManufacturerMutation.mutate(editData);
  };

  return (
    <div>
      <form
        style={{ maxWidth: "600px" }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <h3 className="text-center">Edit Manufacturer</h3>
        <div className="form-group row p-1">
          <label htmlFor="manufacturer_name" className="col-sm-4 col-form-label">
            Manufacturer Name:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="manufacturer_name"
              name="manufacturer_name"
              type="text"
              required
              {...register("manufacturer_name")}
            />
          </div>
        </div>
        <div className="form-group row p-1">
          <label htmlFor="order_num" className="col-sm-4 col-form-label">
            Order Num:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="order_num"
              name="order_num"
              type="number"
              min={0}
              {...register("order_num")}
            />
          </div>
        </div>
        <div className="form-group row p-1">
          <label htmlFor="updated_at" className="col-sm-4 col-form-label">
            Last modified at:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="updated_at"
              name="updated_at"
              type="text"
              disabled
              {...register("updated_at")}
            />
          </div>
        </div>
        <div className="form-group row p-1">
          <label htmlFor="updated_by" className="col-sm-4 col-form-label">
            Modified by:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="updated_by"
              name="updated_by"
              type="text"
              disabled
              {...register("updated_by")}
            />
          </div>
        </div>

        <div
          className="d-flex justify-content-center p-2"
          style={{ gap: "10px" }}
        >
          <button type="submit" className="btn btn-primary">
            {editManufacturerMutation.isLoading && (
              <span>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                &nbsp;
              </span>
            )}
            Submit
          </button>
          <button
            type="button"
            className=" btn btn-danger"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default ManufacturerDetail;
